/* ============================================================================
   RYVT PLP controls — spec §1.3 / §4 AGENT 3. Vanilla, ≤ 2 KB min.
   One <ryvt-plp-controls> wraps the utility bar + the single Filter & sort form:
   - < 750px the form is a RyvtDrawer bottom sheet (role="dialog", scrim, trap —
     all handled by the runtime's <ryvt-drawer> upgrade);
   - ≥ 750px the same node becomes a plain inline disclosure row (dialog
     semantics stripped, `.is-inline-open` display toggle, nothing animates).
   Sort select GET-submits its form on change. Filtering is always a full
   navigation — no AJAX facets in v1.
   ========================================================================== */
(function () {
  'use strict';
  if (customElements.get('ryvt-plp-controls')) return;

  class RyvtPlpControls extends HTMLElement {
    connectedCallback() {
      this._mq = window.matchMedia('(min-width: 750px)');
      this._sheet = this.querySelector('[data-ryvt-filter-sheet]');
      this._toggle = this.querySelector('[data-ryvt-filter-toggle]');

      this._onToggle = this._handleToggle.bind(this);
      this._onChange = this._handleChange.bind(this);
      this._onMq = this._sync.bind(this);

      if (this._toggle) this._toggle.addEventListener('click', this._onToggle);
      this.addEventListener('change', this._onChange);
      if (this._mq.addEventListener) this._mq.addEventListener('change', this._onMq);
      this._sync();
    }

    disconnectedCallback() {
      if (this._toggle) this._toggle.removeEventListener('click', this._onToggle);
      this.removeEventListener('change', this._onChange);
      if (this._mq.removeEventListener) this._mq.removeEventListener('change', this._onMq);
    }

    _handleToggle() {
      var sheet = this._sheet;
      if (!sheet) return;
      if (this._mq.matches) {
        var open = sheet.classList.toggle('is-inline-open');
        this._toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      } else if (typeof sheet.open === 'function') {
        /* Upgraded by ryvt-runtime.js (RyvtDrawer); it owns focus, scrim, Esc. */
        sheet.open(this._toggle);
      }
    }

    _handleChange(event) {
      var select = event.target.closest('[data-ryvt-sort]');
      if (!select || !select.form) return;
      if (select.form.requestSubmit) select.form.requestSubmit();
      else select.form.submit();
    }

    /* Dialog semantics belong to the mobile sheet only; the ≥ 750px inline row
       is a non-modal disclosure region. */
    _sync() {
      var sheet = this._sheet;
      if (!sheet) return;
      if (this._mq.matches) {
        if (sheet.classList.contains('is-open') && typeof sheet.close === 'function') {
          sheet.close();
        }
        sheet.removeAttribute('role');
        sheet.removeAttribute('aria-modal');
        if (this._toggle) {
          this._toggle.setAttribute(
            'aria-expanded',
            sheet.classList.contains('is-inline-open') ? 'true' : 'false'
          );
        }
      } else {
        sheet.classList.remove('is-inline-open');
        sheet.setAttribute('role', 'dialog');
        sheet.setAttribute('aria-modal', 'true');
        if (this._toggle) this._toggle.setAttribute('aria-expanded', 'false');
      }
    }
  }

  customElements.define('ryvt-plp-controls', RyvtPlpControls);
})();
